import Konva from "konva";

function isCanvasTaintError(err: unknown): boolean {
  if (!err || typeof err !== "object") return false;
  const name = (err as { name?: string }).name;
  const message = String((err as { message?: string }).message || "");
  return (
    name === "SecurityError" ||
    message.includes("Tainted canvases") ||
    message.includes("insecure")
  );
}

export function exportChartAsBlob(stage: Konva.Stage): Promise<Blob> {
  return new Promise((resolve, reject) => {
    try {
      stage.toBlob({
        callback: (blob: Blob | null) => {
          if (blob) resolve(blob);
          else
            reject(
              new Error(
                "Failed to export chart as image (the canvas may be tainted). Try reopening the editor.",
              ),
            );
        },
        mimeType: "image/png",
      });
    } catch (err) {
      if (isCanvasTaintError(err)) {
        reject(
          new Error(
            "Could not export the image (canvas is tainted). The base image must load from a same-origin or CORS-enabled URL, or from a local copy. Try closing and reopening markup, or refresh the document list.",
          ),
        );
      } else {
        reject(err);
      }
    }
  });
}

export function downloadChart(
  stage: Konva.Stage,
  filename = "chart-markup.png",
): void {
  const dataUrl = stage.toDataURL({ mimeType: "image/png" });
  const link = window.document.createElement("a");
  link.download = filename;
  link.href = dataUrl;
  window.document.body.appendChild(link);
  link.click();
  window.document.body.removeChild(link);
}
